import Vue from 'vue'
import App from './App.vue'
import PartnersApp from './PartnersApp.vue'
import router from './router'
import partnersRouter from './partners.router'
import store from '@/store'
import Plugin from '@/common/plugins/plugins'
import utils from '@/common/util/utils'
import { IS_SPECIAL_PROMOTION_PAGE } from '@/common/constant'
import { checkMoveCoverPage, goCoverPage } from '@/common/util/cover'

Vue.config.productionTip = false

utils.redirectWithParams()
utils.allowDeviceCheck()
utils.redirectHttpToHttps()

Plugin.init()

function startMobileWeb() {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app')
}

if (IS_SPECIAL_PROMOTION_PAGE) {
  new Vue({
    router: partnersRouter,
    render: (h) => h(PartnersApp),
  }).$mount('#app')
} else {
  if (
    location.pathname === '/signup' ||
    location.pathname === '/direct_login' ||
    location.pathname.includes('/partner/tving/connection')
  ) {
    // cookie에 저장된 credential 정보로 autoLogin 처리 혹은 credential 검증 절차를 거치지 "않는" 페이지에 대한 예외처리
    startMobileWeb()
  } else {
    utils.login.autoLoginProc().then((autoLoginResult) => {
      if (autoLoginResult) {
        // 회원가입 후 진입 | 비밀번호 재설정 후 진입
        window.location.reload(true)
      } else {
        if (checkMoveCoverPage()) {
          goCoverPage()
        } else {
          // 웹뷰 | 단순 credential 만료 여부 검증 유저 | 쿠키에 cs가 없고 credential은 저장되어있는 유저(자동로그인 필요한 유저)는 해당 로직을 수행
          startMobileWeb()
        }
      }
    })
  }
}
